import {
  DropdownList,
  DropdownListType,
  NavList,
} from '@cpm-pr1618001/ng-design-lib';

export const MOBILE_NAVIGATION_MENU: DropdownList[] = [
  {
    id: 0,
    value: '/LandingPage/Home',
    label: 'Home',
    type: 'TEXT' as DropdownListType,
    isSelected: true,
  },
  {
    id: 1,
    value: '/LandingPage/AboutUs',
    label: 'About us',
    type: 'TEXT' as DropdownListType,
    isSelected: false,
  },
  {
    id: 2,
    value: '',
    label: '',
    type: 'DIVIDER' as DropdownListType,
  },
  {
    id: 3,
    value: null,
    label: 'Sign In',
    type: 'TEXT' as DropdownListType,
    isSelected: false,
  },
  {
    id: 4,
    value: null,
    label: 'Sign Up',
    type: 'TEXT' as DropdownListType,
    isSelected: false,
  },
];

export const DESKTOP_NAVIGATION_MENU: NavList[] = [
  { name: 'Home', id: 0, isActive: true, url: '/LandingPage/Home' },
  {
    name: 'About us',
    id: 1,
    isActive: false,
    url: '/LandingPage/AboutUs',
  },
];
